export const ACTIVITY_START = "[NOTIFICATIONS MODULE] Activity Start";
export const GET_ACTIVITIES = "[NOTIFICATIONS MODULE] Get Activities";
export const GET_ACTIVITIES_SUCCESS = "[NOTIFICATIONS MODULE] Get Activities Success";
export const ACTIVITY_FAIL = "[NOTIFICATIONS MODULE] Activity Fail";
